// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLink_modal__img__0dPgB {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.PaymentLink_main_nav__kImQL {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 1rem;
  background-color: var(--color-white);
  box-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);
}
.PaymentLink_main_nav__kImQL > :not(:last-child) {
  margin-right: 6rem;
}
.PaymentLink_main_nav_group__Ubzb4 {
  position: relative;
}
.PaymentLink_main_nav_more__57k\\+Q {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.PaymentLink_main_nav_more__57k\\+Q > :not(last-child) {
  margin-bottom: 1rem;
}
.PaymentLink_main_nav_item__0Nt1P {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.PaymentLink_main_nav_item__0Nt1P:hover, .PaymentLink_main_nav_item__0Nt1P:focus, .PaymentLink_main_nav_item__0Nt1P:focus-visible, .PaymentLink_main_nav_item__0Nt1P:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.PaymentLink_main_nav_item_active__L56NY {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.PaymentLink_main_nav_item_active__L56NY:hover, .PaymentLink_main_nav_item_active__L56NY:focus, .PaymentLink_main_nav_item_active__L56NY:focus-visible, .PaymentLink_main_nav_item_active__L56NY:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.PaymentLink_main__content__SqWj1 {
  margin-top: 5rem;
}
.PaymentLink_main__metrics__i8JBu {
  padding: 3.5rem 2rem;
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .PaymentLink_main__metrics__i8JBu {
    grid-template-columns: repeat(2, 50%);
  }
}
.PaymentLink_main__metrics_active__7tAGv {
  background-color: var(--color-green);
  color: var(--color-white);
}
.PaymentLink_main__metrics_suspended__ToVNo {
  background-color: var(--color-yellow);
}
.PaymentLink_main__metrics_terminated__B1zM9 {
  background-color: var(--color-error);
  color: var(--color-white);
}
.PaymentLink_main__center__-PsUF {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PaymentLink_createLinks__v0eLl {
  display: grid;
  gap: 2rem;
  grid-template-columns: 60% 40%;
}
@media only screen and (max-width: 50em) {
  .PaymentLink_createLinks__v0eLl {
    grid-template-columns: 100%;
  }
}
.PaymentLink_createLinks_1__THBZn {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.PaymentLink_createLinks_2__cU2VL {
  background-color: var(--color-primary-4);
  padding: 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLink_createLinks_2__cU2VL img {
  width: 7rem;
}
.PaymentLink_createLinks_mini__Wbqe3 {
  background-color: var(--color-white);
  padding: 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.PaymentLink_beside__TTT2F {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLink_beside__TTT2F {
    grid-template-columns: 100%;
  }
}

.PaymentLink_status__pending__xvXfj {
  color: var(--color-yellow-3);
}
.PaymentLink_status__paid__KQD1f {
  color: var(--color-green);
}
.PaymentLink_status__failed__Lmabe {
  color: var(--color-error);
}

.PaymentLink_active__EI3tT {
  font-weight: 700;
  color: var(--color-green);
}

.PaymentLink_deactivated__iIkzf {
  font-weight: 700;
  color: var(--color-error);
}

.PaymentLink_flex__5-t4j {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PaymentLink/PaymentLink.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,oCAAA;EACA,gDAAA;AALF;AASE;EACC,kBAAA;AAPH;AAUE;EACC,kBAAA;AARH;AAWE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AATH;AAWG;EACC,mBAAA;AATJ;AAaE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAXH;AAiBG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AAlBJ;AAqBG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAnBJ;AAyBI;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AA1BL;AAgCC;EACC,gBAAA;AA9BF;AAiCC;EAEC,oBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AA/BF;AAiCE;EATD;IAUE,qCAAA;EA9BD;AACF;AAgCE;EACC,oCAAA;EACA,yBAAA;AA9BH;AAiCE;EACC,qCAAA;AA/BH;AAkCE;EACC,oCAAA;EACA,yBAAA;AAhCH;AAoCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCF;;AAsCA;EACC,aAAA;EACA,SAAA;EACA,8BAAA;AAnCD;AAqCC;EALD;IAME,2BAAA;EAlCA;AACF;AAoCC;EACC,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;AAlCF;AAqCC;EACC,wCAAA;EAEA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApCF;AAsCE;EACC,WAAA;AApCH;AAwCC;EACC,oCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,WAAA;AAtCF;;AA0CA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAvCD;AAyCC;EAND;IAOE,2BAAA;EAtCA;AACF;;AA0CC;EACC,4BAAA;AAvCF;AA0CC;EACC,yBAAA;AAxCF;AA2CC;EACC,yBAAA;AAzCF;;AA6CA;EACC,gBAAA;EACA,yBAAA;AA1CD;;AA6CA;EACC,gBAAA;EACA,yBAAA;AA1CD;;AA6CA;EACC,aAAA;EACA,SAAA;EACA,eAAA;AA1CD","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 1rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 1px 5px 10px -5px rgba(0, 0, 0, 0.3);\n\t\t// border-bottom: solid 1px var(--color-dark);\n\t\t// border-radius: 1rem 1rem 0 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 6rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \twidth: 47%;\n\t\t\t\t// }\n\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&:focus-visible,\n\t\t\t\t&:focus-within {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&__content {\n\t\tmargin-top: 5rem;\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 50%);\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_suspended {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_terminated {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n\n\t&__center {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.createLinks {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: 60% 40%;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&_1 {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t}\n\n\t&_2 {\n\t\tbackground-color: var(--color-primary-4);\n\t\t// background-color: var(--color-dark-2);\n\t\tpadding: 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\timg {\n\t\t\twidth: 7rem;\n\t\t}\n\t}\n\n\t&_mini {\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\twidth: 100%;\n\t}\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n.status {\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n.active {\n\tfont-weight: 700;\n\tcolor: var(--color-green);\n}\n\n.deactivated {\n\tfont-weight: 700;\n\tcolor: var(--color-error);\n}\n\n.flex {\n\tdisplay: flex;\n\tgap: 1rem;\n\tflex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `PaymentLink_modal__img__0dPgB`,
	"main_nav": `PaymentLink_main_nav__kImQL`,
	"main_nav_group": `PaymentLink_main_nav_group__Ubzb4`,
	"main_nav_more": `PaymentLink_main_nav_more__57k+Q`,
	"main_nav_item": `PaymentLink_main_nav_item__0Nt1P`,
	"main_nav_item_active": `PaymentLink_main_nav_item_active__L56NY`,
	"main__content": `PaymentLink_main__content__SqWj1`,
	"main__metrics": `PaymentLink_main__metrics__i8JBu`,
	"main__metrics_active": `PaymentLink_main__metrics_active__7tAGv`,
	"main__metrics_suspended": `PaymentLink_main__metrics_suspended__ToVNo`,
	"main__metrics_terminated": `PaymentLink_main__metrics_terminated__B1zM9`,
	"main__center": `PaymentLink_main__center__-PsUF`,
	"createLinks": `PaymentLink_createLinks__v0eLl`,
	"createLinks_1": `PaymentLink_createLinks_1__THBZn`,
	"createLinks_2": `PaymentLink_createLinks_2__cU2VL`,
	"createLinks_mini": `PaymentLink_createLinks_mini__Wbqe3`,
	"beside": `PaymentLink_beside__TTT2F`,
	"status__pending": `PaymentLink_status__pending__xvXfj`,
	"status__paid": `PaymentLink_status__paid__KQD1f`,
	"status__failed": `PaymentLink_status__failed__Lmabe`,
	"active": `PaymentLink_active__EI3tT`,
	"deactivated": `PaymentLink_deactivated__iIkzf`,
	"flex": `PaymentLink_flex__5-t4j`
};
export default ___CSS_LOADER_EXPORT___;
